import { inject } from '@angular/core';

import {
  HttpInterceptorFn
} from '@angular/common/http';

import { createUrl } from '../services/api.util';
import { JwtService } from '../services/jwt.service';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {

  const jwtService = inject(JwtService);

  const token = jwtService.getJWTString();

  if (
    !req.url.startsWith(`${createUrl().replace(/\/+$/, '')}/`) || req.url === createUrl('auth', 'login')
  ) {
    return next(req);
  }

  if (token) {

    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(req);
};